export default __webpack_public_path__ + "static/media/iossettings3.e25b6efd.png";